(function () {
    window.VRPanelsSlidingManager = {
        selectedEl: null,
        _leftPanelOrig: null,
        _rightPanelOrig: null,
        _leftPanelBaseScale: null,
        _rightPanelBaseScale: null,

        _initGlobalDeselect: function () {
            window.addEventListener('mousedown', (evt) => {
                if (evt.target.tagName !== 'CANVAS') return;
                
                const cursors = document.querySelectorAll('[raycaster]');
                let hasIntersection = false;
                
                cursors.forEach(c => {
                    const rc = c.components.raycaster;
                    if (rc && rc.intersectedEls && rc.intersectedEls.length > 0) {
                        hasIntersection = true;
                    }
                });

                if (!hasIntersection) {
                    this.setSelectedEl(null);
                    this.dimOtherStockBars(null);
                }
            });
        },

        _isSuspended: false,

        suspendPanels: function () {
            if (!this.selectedEl || this._isSuspended) return;
            this.restorePanelsInstantly();
            this._isSuspended = true;
        },

        resumePanels: function () {
            if (!this.selectedEl || !this._isSuspended) return;
            this._isSuspended = false;
            this.slidePanelsOut();
        },

        setSelectedEl: function (el) {
            const prevSelected = this.selectedEl;
            if (el === prevSelected) return;

            if (!prevSelected && el) {
                if (this._canApplySlideAndHover()) {
                    this.slidePanelsOut();
                    this._isSuspended = false;
                } else {
                    this._isSuspended = true;
                }
            } else if (prevSelected && !el) {
                if (!this._isSuspended) {
                    this.restorePanels();
                }
                this._isSuspended = false;
            }
            this.selectedEl = el;

            this.updateRaycastable();
        },

        _canApplySlideAndHover: function () {
            const carouselEl = document.querySelector('#carousel') || document.querySelector('[main-elements-moving]');
            if (carouselEl && carouselEl.components['main-elements-moving']) {
                const currentStep = carouselEl.components['main-elements-moving'].data.currentStep;
                if (currentStep !== 0) {
                    return false;
                }
            }

            const mainSettingsEl = document.querySelector('#main-settings-popup');
            const mainSettings = mainSettingsEl && mainSettingsEl.components['main-settings'];
            if (mainSettings && mainSettings.isRepositioning) {
                return false;
            }

            return true;
        },

        _isPanelRepositioned: function (panel, defaultPosStr) {
            if (!panel) return false;
            try {
                const savedData = (typeof getCacheItem === 'function') 
                    ? getCacheItem('userPanelPositions') 
                    : null;
                if (savedData) {
                    const panelIdKey = panel.id === 'left-panel-2' ? 'leftPanel' : 
                                       (panel.id === 'right-container' ? 'rightPanel' : 
                                       (panel.id === 'large-center-panel' ? 'centralPanel' : null));
                    if (panelIdKey && savedData[panelIdKey] && savedData[panelIdKey].position) {
                        const savedPosStr = savedData[panelIdKey].position;
                        if (defaultPosStr) {
                            const defParts = defaultPosStr.split(' ').map(Number);
                            const savedParts = savedPosStr.split(' ').map(Number);
                            if (defParts.length === 3 && savedParts.length === 3) {
                                const dist = Math.sqrt(
                                    Math.pow(defParts[0] - savedParts[0], 2) +
                                    Math.pow(defParts[1] - savedParts[1], 2) +
                                    Math.pow(defParts[2] - savedParts[2], 2)
                                );
                                return dist > 0.05;
                            }
                        }
                    }
                }
            } catch (e) {
                console.warn('Error checking userPanelPositions', e);
            }
            return false;
        },

        _animateEl: function (el, property, toValue, dur) {
            const animKey = 'animation__ng_' + property.replace('.', '_');
            el.setAttribute(animKey, {
                property,
                to: toValue,
                dur: dur || 600,
                easing: 'easeInOutQuad'
            });
        },

        slidePanelsOut: function () {
            if (!this._canApplySlideAndHover()) return;
            const DUR = 600;
            const leftPanel  = document.getElementById('left-panel-2');
            const rightPanel = document.getElementById('right-container');

            if (leftPanel) {
                const defPosStr = leftPanel.getAttribute('default-position');
                const isRepositioned = this._isPanelRepositioned(leftPanel, defPosStr);
                if (!isRepositioned) {
                    if (!this._leftPanelOrig) {
                        const defPos = defPosStr || leftPanel.object3D.position;
                        const p = (typeof defPos === 'string') ? defPos.trim() : `${defPos.x} ${defPos.y} ${defPos.z}`;
                        const rot = leftPanel.getAttribute('rotation') || { x: 0, y: 0, z: 0 };
                        const rStr = (typeof rot === 'string') ? rot.trim() : `${rot.x} ${rot.y} ${rot.z}`;
                        this._leftPanelOrig = { pos: p, rot: rStr };
                    }
                    const parts = this._leftPanelOrig.pos.split(' ').map(Number);
                    this._animateEl(leftPanel, 'position', `${parts[0] - 0.4} ${parts[1]} ${parts[2] + 0.7}`, DUR);
                    this._animateEl(leftPanel, 'rotation', '0 20 0', DUR);

                    const leftArrow = document.getElementById('left-triangle-arrow-model');
                    if (leftArrow) {
                        this._animateEl(leftArrow, 'position', '-2.120 2.2 -1.9', DUR);
                    }
                }
            }

            if (rightPanel) {
                const defPosStr = rightPanel.getAttribute('default-position');
                const isRepositioned = this._isPanelRepositioned(rightPanel, defPosStr);
                if (!isRepositioned) {
                    if (!this._rightPanelOrig) {
                        const defPos = defPosStr || rightPanel.object3D.position;
                        const p = (typeof defPos === 'string') ? defPos.trim() : `${defPos.x} ${defPos.y} ${defPos.z}`;
                        const rot = rightPanel.getAttribute('rotation') || { x: 0, y: 0, z: 0 };
                        const rStr = (typeof rot === 'string') ? rot.trim() : `${rot.x} ${rot.y} ${rot.z}`;
                        this._rightPanelOrig = { pos: p, rot: rStr };
                    }
                    const parts = this._rightPanelOrig.pos.split(' ').map(Number);
                    this._animateEl(rightPanel, 'position', `${parts[0] + 0.4} ${parts[1]} ${parts[2] + 0.7}`, DUR);
                    this._animateEl(rightPanel, 'rotation', '0 -20 0', DUR);

                    const rightArrow = document.getElementById('right-triangle-arrow-model');
                    if (rightArrow) {
                        this._animateEl(rightArrow, 'position', '2.120 2.2 -1.9', DUR);
                    }
                }
            }
        },

        restorePanelsInstantly: function () {
            const leftPanel  = document.getElementById('left-panel-2');
            const rightPanel = document.getElementById('right-container');

            if (leftPanel && this._leftPanelOrig) {
                leftPanel.removeAttribute('animation__ng_position');
                leftPanel.removeAttribute('animation__ng_rotation');
                const parts = this._leftPanelOrig.pos.split(' ').map(Number);
                leftPanel.object3D.position.set(parts[0], parts[1], parts[2]);
                leftPanel.setAttribute('position', this._leftPanelOrig.pos);
                leftPanel.setAttribute('rotation', this._leftPanelOrig.rot);

                const leftArrow = document.getElementById('left-triangle-arrow-model');
                if (leftArrow) {
                    leftArrow.removeAttribute('animation__ng_position');
                    leftArrow.object3D.position.set(-1.8, 2.2, -1.9);
                    leftArrow.setAttribute('position', '-1.8 2.2 -1.9');
                }
            }

            if (rightPanel && this._rightPanelOrig) {
                rightPanel.removeAttribute('animation__ng_position');
                rightPanel.removeAttribute('animation__ng_rotation');
                const parts = this._rightPanelOrig.pos.split(' ').map(Number);
                rightPanel.object3D.position.set(parts[0], parts[1], parts[2]);
                rightPanel.setAttribute('position', this._rightPanelOrig.pos);
                rightPanel.setAttribute('rotation', this._rightPanelOrig.rot);

                const rightArrow = document.getElementById('right-triangle-arrow-model');
                if (rightArrow) {
                    rightArrow.removeAttribute('animation__ng_position');
                    rightArrow.object3D.position.set(1.8, 2.2, -1.9);
                    rightArrow.setAttribute('position', '1.8 2.2 -1.9');
                }
            }
        },

        restorePanels: function () {
            const DUR = 600;
            const leftPanel  = document.getElementById('left-panel-2');
            const rightPanel = document.getElementById('right-container');

            if (leftPanel && this._leftPanelOrig) {
                const defPosStr = leftPanel.getAttribute('default-position');
                const isRepositioned = this._isPanelRepositioned(leftPanel, defPosStr);
                if (!isRepositioned) {
                    this._animateEl(leftPanel, 'position', this._leftPanelOrig.pos, DUR);
                    this._animateEl(leftPanel, 'rotation', this._leftPanelOrig.rot, DUR);

                    const leftArrow = document.getElementById('left-triangle-arrow-model');
                    if (leftArrow) {
                        this._animateEl(leftArrow, 'position', '-1.8 2.2 -1.9', DUR);
                    }
                }
                this._leftPanelOrig = null;
            }
            if (rightPanel && this._rightPanelOrig) {
                const defPosStr = rightPanel.getAttribute('default-position');
                const isRepositioned = this._isPanelRepositioned(rightPanel, defPosStr);
                if (!isRepositioned) {
                    this._animateEl(rightPanel, 'position', this._rightPanelOrig.pos, DUR);
                    this._animateEl(rightPanel, 'rotation', this._rightPanelOrig.rot, DUR);

                    const rightArrow = document.getElementById('right-triangle-arrow-model');
                    if (rightArrow) {
                        this._animateEl(rightArrow, 'position', '1.8 2.2 -1.9', DUR);
                    }
                }
                this._rightPanelOrig = null;
            }
        },

        updateRaycastable: function () {
            const leftPanel = document.getElementById('left-panel-2');
            const rightPanel = document.getElementById('right-container');

            if (this.selectedEl) {
                if (this._canApplySlideAndHover()) {
                    if (leftPanel) {
                        const bgDark = leftPanel.querySelector('.background-panel-dark');
                        const bgLight = leftPanel.querySelector('.background-panel-light');
                        if (bgDark) bgDark.setAttribute('data-raycastable', '');
                        if (bgLight) bgLight.setAttribute('data-raycastable', '');
                    }
                    if (rightPanel) {
                        const bgDark = rightPanel.querySelector('.background-panel-dark');
                        const bgLight = rightPanel.querySelector('.background-panel-light');
                        if (bgDark) bgDark.setAttribute('data-raycastable', '');
                        if (bgLight) bgLight.setAttribute('data-raycastable', '');
                    }
                }
            } else {
                if (leftPanel) {
                    const bgDark = leftPanel.querySelector('.background-panel-dark');
                    const bgLight = leftPanel.querySelector('.background-panel-light');
                    if (bgDark) bgDark.removeAttribute('data-raycastable');
                    if (bgLight) bgLight.removeAttribute('data-raycastable');
                    
                    const backing = leftPanel.querySelector('.ng-backing-panel');
                    if (backing) backing.setAttribute('visible', false);
                }
                if (rightPanel) {
                    const bgDark = rightPanel.querySelector('.background-panel-dark');
                    const bgLight = rightPanel.querySelector('.background-panel-light');
                    if (bgDark) bgDark.removeAttribute('data-raycastable');
                    if (bgLight) bgLight.removeAttribute('data-raycastable');
                    
                    const backing = rightPanel.querySelector('.ng-backing-panel');
                    if (backing) backing.setAttribute('visible', false);
                }
                this._applyPanelHover(leftPanel, false);
                this._applyPanelHover(rightPanel, false);
            }
        },

        setupPanelHoverEffects: function () {
            const leftPanel = document.getElementById('left-panel-2');
            if (leftPanel) {
                leftPanel.addEventListener('mouseenter', (evt) => {
                    if (!this._canApplySlideAndHover()) return;
                    const bgDark = leftPanel.querySelector('.background-panel-dark');
                    const bgLight = leftPanel.querySelector('.background-panel-light');
                    if (this.selectedEl && (evt.target === bgDark || evt.target === bgLight)) {
                        this._applyPanelHover(leftPanel, true);
                    }
                });
                leftPanel.addEventListener('mouseleave', () => {
                    this._applyPanelHover(leftPanel, false);
                });
            }

            const rightPanel = document.getElementById('right-container');
            if (rightPanel) {
                rightPanel.addEventListener('mouseenter', (evt) => {
                    if (!this._canApplySlideAndHover()) return;
                    const bgDark = rightPanel.querySelector('.background-panel-dark');
                    const bgLight = rightPanel.querySelector('.background-panel-light');
                    if (this.selectedEl && (evt.target === bgDark || evt.target === bgLight)) {
                        this._applyPanelHover(rightPanel, true);
                    }
                });
                rightPanel.addEventListener('mouseleave', () => {
                    this._applyPanelHover(rightPanel, false);
                });
            }
        },

        _getActiveBackground: function (panel) {
            if (!panel) return null;
            const bgDark = panel.querySelector('.background-panel-dark');
            const bgLight = panel.querySelector('.background-panel-light');
            if (bgDark && bgDark.getAttribute('visible') !== 'false' && bgDark.getAttribute('visible') !== false) {
                return bgDark;
            }
            if (bgLight && bgLight.getAttribute('visible') !== 'false' && bgLight.getAttribute('visible') !== false) {
                return bgLight;
            }
            return bgDark || bgLight;
        },

        _createBackingPanel: function (panel) {
            if (!panel) return null;
            
            const bg = this._getActiveBackground(panel);
            if (!bg) return null;
            
            const backing = document.createElement('a-rounded-box');
            
            const w = parseFloat(bg.getAttribute('width')) || 1.2;
            const h = parseFloat(bg.getAttribute('height')) || 1.9;
            const r = parseFloat(bg.getAttribute('radius')) || 0.05;
            const d = parseFloat(bg.getAttribute('depth')) || 0.002;
            
            const backingDepth = 0.001;
            
            const sc = bg.getAttribute('scale') || { x: 1, y: 1, z: 1 };
            
            const parentScale = panel.getAttribute('scale') || { x: 1, y: 1, z: 1 };
            const parentScX = typeof parentScale.x === 'number' ? parentScale.x : parseFloat(parentScale.x) || 1;
            const parentScY = typeof parentScale.y === 'number' ? parentScale.y : parseFloat(parentScale.y) || 1;
            
            const combinedScX = sc.x * parentScX;
            const combinedScY = sc.y * parentScY;
            
            const targetWorldBorder = 0.015;
            const borderX = targetWorldBorder / combinedScX;
            const borderY = targetWorldBorder / combinedScY;
            
            backing.setAttribute('width', w + borderX);
            backing.setAttribute('height', h + borderY);
            backing.setAttribute('depth', backingDepth);
            backing.setAttribute('radius', r);
            backing.setAttribute('color', '#3636E3');
            backing.setAttribute('opacity', 0);
            backing.setAttribute('visible', false);
            
            const pos = bg.getAttribute('position') || { x: 0, y: 0, z: 0 };
            const zPos = pos.z - d / 2 - backingDepth / 2 - 0.001;
            backing.setAttribute('position', `${pos.x} ${pos.y} ${zPos}`);
            
            backing.setAttribute('scale', `${sc.x} ${sc.y} ${sc.z}`);
            
            panel.appendChild(backing);
            
            backing.setAttribute('advanced-material', 'renderOrder: -1; depthWrite: false; depthTest: true');
            
            return backing;
        },

        _getOrCreateBackingPanel: function (panel) {
            if (!panel) return null;
            
            let backing = panel.querySelector('.ng-backing-panel');
            if (backing) return backing;
            
            backing = this._createBackingPanel(panel);
            if (backing) {
                backing.classList.add('ng-backing-panel');
            }
            return backing;
        },

        _getQualityLevel: function () {
            if (typeof getCacheItem === 'function') {
                const mainSettings = getCacheItem('mainSettings');
                if (mainSettings && mainSettings.quality) {
                    return mainSettings.quality;
                }
            }
            const isMobile = /(iPhone|iPad|iPod|Android|Mobi|Tablet)/i.test(navigator.userAgent);
            return isMobile ? 'performance' : 'quality';
        },

        _getChartType: function () {
            if (typeof getCacheItem === 'function') {
                return getCacheItem('lastChartType') || ''
            } else return ''
        },

        _applyPanelHover: function (panel, isHovered) {
            if (!panel) return;
            
            const DUR = 250;
            
            if (panel.id === 'left-panel-2' && !this._leftPanelBaseScale) {
                const sc = panel.getAttribute('scale') || { x: 1.2, y: 0.75, z: 1 };
                this._leftPanelBaseScale = {
                    x: typeof sc.x === 'number' ? sc.x : parseFloat(sc.x) || 1.2,
                    y: typeof sc.y === 'number' ? sc.y : parseFloat(sc.y) || 0.75,
                    z: typeof sc.z === 'number' ? sc.z : parseFloat(sc.z) || 1
                };
            }
            if (panel.id === 'right-container' && !this._rightPanelBaseScale) {
                const sc = panel.getAttribute('scale') || { x: 5.6, y: 3.6, z: 1 };
                this._rightPanelBaseScale = {
                    x: typeof sc.x === 'number' ? sc.x : parseFloat(sc.x) || 5.6,
                    y: typeof sc.y === 'number' ? sc.y : parseFloat(sc.y) || 3.6,
                    z: typeof sc.z === 'number' ? sc.z : parseFloat(sc.z) || 1
                };
            }

            const baseScale = panel.id === 'left-panel-2' ? this._leftPanelBaseScale : this._rightPanelBaseScale;
            if (baseScale) {
                const targetScale = isHovered 
                    ? `${baseScale.x * 1.02} ${baseScale.y * 1.02} ${baseScale.z * 1.02}`
                    : `${baseScale.x} ${baseScale.y} ${baseScale.z}`;
                    
                panel.setAttribute('animation__ng_scale', {
                    property: 'scale',
                    to: targetScale,
                    dur: DUR,
                    easing: 'easeOutQuad'
                });
            }

            const backing = this._getOrCreateBackingPanel(panel);
            if (backing) {
                if (isHovered) {
                    backing.setAttribute('visible', true);
                }
                backing.setAttribute('animation__ng_back_opacity', {
                    property: 'rounded-box.opacity',
                    to: isHovered ? 0.99 : 0,
                    dur: DUR,
                    easing: 'easeOutQuad'
                });

                const updateEmissive = () => {
                    const mesh = backing.getObject3D('mesh');
                    if (mesh && mesh.material) {
                        if (mesh.material.emissive && typeof mesh.material.emissive.set === 'function') {
                            const isQuality = this._getQualityLevel() === 'quality';
                            if (isQuality) {
                                mesh.material.emissive.set('#7979FC');
                                mesh.material.emissiveIntensity = isHovered ? 4.0 : 0.0;
                                mesh.material.toneMapped = false;
                            } else {
                                mesh.material.emissive.set('#3636E3');
                                mesh.material.emissiveIntensity = isHovered ? 1.0 : 0.0;
                                mesh.material.toneMapped = true;
                            }
                            mesh.material.needsUpdate = true;
                        }
                    }
                };

                const mesh = backing.getObject3D('mesh');
                if (mesh) {
                    updateEmissive();
                } else {
                    backing.addEventListener('object3dset', function handler(evt) {
                        if (evt.detail.type === 'mesh') {
                            updateEmissive();
                            backing.removeEventListener('object3dset', handler);
                        }
                    });
                }
            }
        },

        dimOtherStockBars: function (selectedBarEl) {
            const allBars = document.querySelectorAll('[stock-bar]');
            const defaultBarOpacity = this._getChartType().includes('mmap') ? 1 : 0.65

            allBars.forEach(barEl => {
                try {
                    const isSelected = (barEl === selectedBarEl);
                    const targetOpacity = (!selectedBarEl) ? defaultBarOpacity : (isSelected ? 1 : 0.1);
                    
                    if (barEl.object3D) {
                        barEl.object3D.traverse(node => {
                            if (node.isMesh && node.material) {
                                const mats = Array.isArray(node.material) ? node.material : [node.material];
                                mats.forEach(m => {
                                    m.opacity = targetOpacity;
                                    m.transparent = true;
                                    m.needsUpdate = true;
                                });
                            }
                        });
                    } else {
                        barEl.setAttribute('material', 'opacity', targetOpacity);
                    }
                    
                    const labelEl = barEl.__primaryLabel;
                    if (labelEl) {
                        const targetLabelOpacity = (!selectedBarEl) ? 1.0 : (isSelected ? 1.0 : 0.3);
                        labelEl.setAttribute('animation__dim_fill', {
                            property: 'fill-opacity',
                            from: 1,
                            to: targetLabelOpacity,
                            dur: 300,
                            easing: 'easeInOutQuad'
                        });
                        labelEl.setAttribute('animation__dim_out', {
                            property: 'outline-opacity',
                            from: 1,
                            to: targetLabelOpacity,
                            dur: 300,
                            easing: 'easeInOutQuad'
                        });
                    }
                } catch (e) {
                    console.warn('Error setting material opacity on stock bar:', e);
                }
            });
        }
    };

    document.addEventListener('DOMContentLoaded', () => {
        window.VRPanelsSlidingManager.setupPanelHoverEffects();
    });

    window.VRPanelsSlidingManager._initGlobalDeselect();
})();
